import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import Modal from '../../../components/Modal';
import { Context } from "../../../config/store";
import objectToQueryParams from '../../../common/objectToQueryParams';

const SearchFilter = ({ setQueryParams, errors, loading }) => {
    let searchData = JSON.parse(sessionStorage.getItem('searchData'));
	const getParamsFromSessionStorage = (key, type = null) => {
		let searchDataResult = searchData ? searchData[key] : '';
		if (type === 'date' && searchDataResult) {
			let convertedDate = searchDataResult?.split('/')
			return new Date(`${convertedDate[1]}/${convertedDate[0]}/${convertedDate[2]}`)
		}
		return searchDataResult;
	}

    const [assignLender, setAssignLender] = React.useState(getParamsFromSessionStorage('assignLender'));
	const [lafId, setLafId] = React.useState(getParamsFromSessionStorage('laf_id'));
	const [customerName, setCustomerName] = React.useState(getParamsFromSessionStorage('customer_name'));
	const [isLoading, setIsLoading] = React.useState(false)
    const [modalState, setModalState] = useState(['16','20','15', '1', '2'].includes(getParamsFromSessionStorage('assignLender')) ? false : true)
    const { state } = React.useContext(Context);

    const submitQueryParams = () => {
        if(!assignLender){
            toggleModal()
            return;
        }
        setModalState(false);
        setIsLoading(true)
        const searchObject = {
            assignLender: assignLender,
            laf_id: lafId,
            customer_name: customerName
        };
        sessionStorage.setItem('searchData', JSON.stringify({ ...searchObject, org_page: 1 }))
        let queryString = objectToQueryParams(searchObject);
        setQueryParams(queryString);
        setTimeout(() => {
        	setIsLoading(false)
        }, 500);
    };

    const resetQueryParams = () => {
        sessionStorage.removeItem('searchData')
        setCustomerName('')
        setLafId('')
        setAssignLender(0)
        setQueryParams('');
    };

    const toggleModal = () => {
        setModalState(!modalState)
    }

    const checkHasPermission = tabMenu => {
		if (state.is_super_admin === 1) return tabMenu;
		const permission = (state.permission || []).find(
			permission => (tabMenu).split(',').includes(permission)
		);

		if (permission) return tabMenu;
		else return false;
	};

    return (
        <>
        <div className='tab panel overflow-unset mt-2 mb-0 p-3'>
            <div className="row">
                <div className="col-md-4">
                    <div className='form-group'>
                        <label>LAF ID </label>
                        <input
                            className='form-control'
                            value={lafId}
                            maxLength={40}
                            onChange={(e) => setLafId(e.target.value.replace(/[_\W]+/g, ""))}
                        />
                        <tt>
                            {errors && errors?.laf_id}
                        </tt>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className='form-group'>
                        <label>Customer Name</label>
                        <input
                            value={customerName}
                            maxLength={100}
                            onChange={(e) => setCustomerName(e.target.value.replace(/[^A-Za-z0-9().,/\s]+/gi, ""))}
                            type='text'
                            className='form-control'
                        />
                        <tt>
                            {errors && errors?.customer_name}
                        </tt>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className='form-group'>
                        <label>Lender</label>
                        <select
                            value={assignLender}
                            onChange={(e) => setAssignLender(e.target.value)}
                            className='form-control'
                            placeholder=''
                            style={{ fontSize: '11px' }}
                        >
                            <option value={''}>Select Lender</option>
                            <option value={1}>State Bank of India</option>
                            <option value={16}>Karur Vysya Bank</option>
                            <option value={20}>Karnataka Bank</option>
                            <option value={15}>UCO Bank</option>
                            <option value={2}>IDBI Bank</option>
                        </select>
                        <tt>
                            {errors && errors?.assignLender}
                        </tt>
                    </div>
                </div>
            </div>
            <div className='row d-flex mt-2'>
                <div className='col-md-9 d-flex'>
                    <button
                        onClick={submitQueryParams}
                        disabled={isLoading || loading}
                        type='button'
                        className='btn btn-custom btn-custom-height'
                        id='submitButton'
                    >
                        {isLoading || loading ? <div className="loader"></div> : 'Search'}
                    </button>
                    <button
                        onClick={resetQueryParams}
                        type='button'
                        className='btn btn-custom btn-custom-height ml-2'
                    >
                        Reset All
                    </button>
                </div>
                {[20,15,1,2].includes(Number(assignLender)) && checkHasPermission('collection-info-upload') && <div className='col-md-3 d-flex'>
                    <Link to={'/additional-info-upload/collection/'+assignLender} style={{marginLeft:'78px'}}>
                        <button
                            type='button'
                            className='btn btn-custom btn-custom-height ml-2'
                            onClick={()=>{localStorage.setItem('selectedColender', '/portfolio/collections')}}
                        >
                            Upload Collection Info
                        </button>
					</Link>
                    
                </div>}
            </div>
        </div>
        <Modal state={modalState} closeModal={toggleModal} style={{ width: "450px" }} removeBorderSpace={true} closeOnOverlayClick={false}>
        <div className="modal-header-container">
          <div className="modal-title">Select Lender</div>
          {/* <div className="closeModalView" onClick={toggleModal}>
            <span className="closeModalIcon">x</span>
          </div> */}
        </div>
        <div className='p-4'>
            <div style={{ overflowY: "scroll", overflowX: 'clip', padding: "2%" }}>
              <div class='form-group'>
                <label>Lender<tt>*</tt></label>
                <div class='row'>
                  <div class='col-12'>
                    <select
                      class='form-control custom-form-control'
                      onChange={(e) => setAssignLender(e.target.value)}
                      value={assignLender}
                    >
                      <option value={''}>Please Select</option>
                      <option value={1}>{"State Bank of India"}</option>
                      <option value={16}>{"Karur Vysya Bank"}</option>
                      <option value={20}>{"Karnataka Bank"}</option>
                      <option value={15}>{"UCO Bank"}</option>
                      <option value={2}>{"IDBI Bank"}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class='d-flex align-items-center justify-content-center mt-3'>
              <button type='submit' class='btn btn-custom' disabled={loading || !assignLender} onClick={submitQueryParams}>
                {loading ? <div className='loader' /> : 'OK'}
              </button>
              <button
                type='button'
                class='btn btn-outline-custom ml-2'
                data-dismiss='modal'
                onClick={() => {
                //   sessionStorage.removeItem('searchData')
                //   navigate(state.selectedColender)
                    // history.back();
                    setAssignLender(0)
                    toggleModal()
                }}
              >
                Cancel
              </button>
            </div>
        </div>
      </Modal>
      </>
    )
}

export default SearchFilter
